import { toast } from 'react-toastify'

export const successToast = (text?: string): void => {
  toast.success(text || 'Success!')
}

export const errorToast = (text?: string): void => {
  toast.error(text || 'Error!')
}
